module.exports = __webpack_public_path__ + "static/media/addEmployee.039bc713.png";